import React from "react";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

export default function MacthFromTag({
  brandName,
  tooltipText,
}: {
  brandName: string;
  tooltipText?: string;
}) {
  const { t } = useTranslation();
  return (
    <Tooltip color="#000" title={tooltipText}>
      <div className="border mt-2 border-[#D7D3D0] rounded-md whitespace-nowrap px-2 h-[24px] flex items-center justify-center w-fit">
        <div className="text-center justify-start text-Colors-Text-text-secondary-(700) text-xs font-medium font-['DM_Sans'] leading-4">
          {t("components.matchFromTag.matchedFrom", { defaultValue: "Matched from {brandName}", brandName })}
        </div>
      </div>
    </Tooltip>
  );
}
